import React, { useEffect, useRef, useState } from 'react';
import { QRCodeCanvas } from 'qrcode.react';
import { Share2, Download } from 'lucide-react';
import { Button } from '../ui/button';
import { toast } from 'sonner';
import { nativeFile } from '../../lib/androidApp';

export const RequestQR = ({ request, prefix }) => {
  const canvas = useRef(null);
  const [file, setFile] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    let active = true; setFile(null);
    canvas.current?.toBlob(blob => { if (active && blob) setFile(new File([blob], `MALDHOWR-request-${request.id}.png`, { type: 'image/png' })); }, 'image/png');
    return () => { active = false; };
  }, [request.id, request.link]);
  const exportQR = async sharing => {
    if (!file || busy) return; setBusy(true);
    try {
      if (await nativeFile(sharing ? 'share' : 'download', file, file.name)) return;
      if (sharing && navigator.canShare?.({ files: [file] })) { await navigator.share({ title: 'MALDHOWR', files: [file] }); return; }
      const url = URL.createObjectURL(file); const anchor = document.createElement('a');
      anchor.href = url; anchor.download = file.name; document.body.appendChild(anchor); anchor.click(); anchor.remove(); setTimeout(() => URL.revokeObjectURL(url), 1000);
    } catch (failure) { if (failure.name !== 'AbortError') toast.error('Could not share request QR.'); }
    finally { setBusy(false); }
  };
  return <section data-testid={`${prefix}-qr-panel`}>
    <div className="payment-qr-frame"><QRCodeCanvas ref={canvas} data-testid={`${prefix}-qr`} value={request.link} size={600} marginSize={4} level="M" /></div>
    <div className="flex flex-wrap justify-center gap-3 mb-5"><Button data-testid={`${prefix}-share-qr`} type="button" variant="outline" className="customer-secondary" disabled={!file || busy} onClick={() => exportQR(true)}><Share2 size={15} className="mr-2" />Share QR</Button><Button data-testid={`${prefix}-download-qr`} type="button" variant="outline" className="customer-secondary" disabled={!file || busy} onClick={() => exportQR(false)}><Download size={15} className="mr-2" />Download QR</Button></div>
  </section>;
};